import GetLoading from "../../share/getLoading";

import { Outlet, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
  // Tabler Icons - Correct names from the available exports
  IconMail,
  IconHome,
  IconUser,
  IconSettings,
  IconLogout,
  IconLock,
  IconChevronRight,
  IconChevronLeft,
  IconChevronDown,
  IconLayoutDashboard,
  IconUsers,
  IconBuilding,
  IconAward,
  IconCertificate,
  IconClipboardList,
  IconFileText,
  IconFileDescription,
  IconChartBar,
  IconCalendar,
  IconCar,
  IconFile,
  IconMailForward,
  IconUserShare,
  IconBrandTelegram,
  IconChartLine,
  IconBuildingBank,
  IconCurrencyDollar,
  IconUserCircle,
  IconUserCheck,
  IconShieldCheck,
  IconDroplet,
  IconFirstAidKit,
  IconChartPie,
  IconMenu2,
} from "@tabler/icons-react";
import {
  // Keep Ant Design components
  Grid,
  Input,
  Form,
  Modal,
  Layout,
  Menu,
  Button,
  theme,
  Breadcrumb,
  Tag,
  Dropdown,
  Space,
  Badge,
  Avatar,
} from "antd";
import {
  getCurrentUser,
  getPermission,
  isGetLogin,
} from "../../share/getProfile";
import "../../styles/Home-module.css";
import "../../styles/FontKhmer.css";
import "./SlideMenu.css";
import styels from "../../page/auth/LoginPage.module.css";
import { openNotification } from "../../share/message";
import { request } from "../../share/request";
import { linkPath } from "../../share/helper";
import { useTranslation } from "react-i18next";

import ModernSidebar from "./ModernSidebar";
import { MessageFilled } from "@ant-design/icons";

const { Header, Sider, Content, Footer } = Layout;

function getItem(label, key, icon, disabled = false, children, type) {
  return {
    key,
    icon,
    disabled,
    children,
    label,
    type,
  };
}
const userProfile = getCurrentUser();
const userPermission = getPermission() || [];

// PERMISSIONS FETCH
const staffValue = userPermission.find(p => p.pagename === "staff") || { pageshow: 0 };
const { pageshow: StaffValue } = staffValue;
const departmentValue = userPermission.find(p => p.pagename === "department") || { pageshow: 0 };
const { pageshow: DepartmentValue } = departmentValue;
const positionValue = userPermission.find(p => p.pagename === "position") || { pageshow: 0 };
const { pageshow: PositionValue } = positionValue;
const setupValue = userPermission.find(p => p.pagename === "setuptype") || { pageshow: 0 };
const { pageshow: SetupValue } = setupValue;
const leavereportValue = userPermission.find(p => p.pagename === "leavereport") || { pageshow: 0 };
const { pageshow: LeaveReportValue } = leavereportValue;
const staffreportValue = userPermission.find(p => p.pagename === "staffreport") || { pageshow: 0 };
const { pageshow: StaffReportValue } = staffreportValue;
const staffscheduleValue = userPermission.find(p => p.pagename === "staffschedule") || { pageshow: 0 };
const { pageshow: StaffScheduleValue } = staffscheduleValue;
const letterspageValue = userPermission.find(p => p.pagename === "letterspage") || { pageshow: 0 };
const { pageshow: LettersValue } = letterspageValue;
const skillpageValue = userPermission.find(p => p.pagename === "skillpage") || { pageshow: 0 };
const { pageshow: SkillValue } = skillpageValue;
const attendance = userPermission.find(p => p.pagename === "attendance") || { pageshow: 0 };
const { pageshow: AttendanceValue } = attendance;
const caractivity = userPermission.find(p => p.pagename === "caractivity") || { pageshow: 0 };
const { pageshow: CarActivityValue } = caractivity;
const rightmanager = userPermission.find(p => p.pagename === "rightmanager") || { pageshow: 0 };
const { pageshow: RightManagerValue } = rightmanager;
const roleValue = userPermission.find(p => p.pagename === "role") || { pageshow: 0 };
const { pageshow: RoleValue } = roleValue;
const caseValue = userPermission.find(p => p.pagename === "case") || { pageshow: 0 };
const { pageshow: CaseValue } = caseValue;
const bankValue = userPermission.find(p => p.pagename === "bankreport") || { pageshow: 0 };
const { pageshow: BankValue } = bankValue;
const CaseGraphic_Values = userPermission.find(p => p.pagename === "casegraphic") || { pageshow: 0 };
const { pageshow: CaseGraphicValue } = CaseGraphic_Values;
const CaseWeekendReport_Values = userPermission.find(p => p.pagename === "caseweekendreport") || { pageshow: 0 };
const { pageshow: CaseWeekendReportValues } = CaseWeekendReport_Values;
const Telegrambotsetting_Values = userPermission.find(p => p.pagename === "telegrambotsetting") || { pageshow: 0 };
const { pageshow: TelegramBotSettingValues } = Telegrambotsetting_Values;
const Request_Mission_Value = userPermission.find(p => p.pagename === "requestmission") || { pageshow: 0 };
const { pageshow: RequestMissionValue } = Request_Mission_Value;
const Accident_Value = userPermission.find(p => p.pagename === "accident_form") || { pageshow: 0 };
const { pageshow: AccidentValue } = Accident_Value;
const BloodDonation_Value = userPermission.find(p => p.pagename === "blood_donation") || { pageshow: 0 };
const { pageshow: BloodDonationValue } = BloodDonation_Value;

const TelegramSendMessage_Value = userPermission.find(p => p.pagename === "telegram_send_message") || { pageshow: 0 };
const { pageshow: TelegramSendMessageValue } = TelegramSendMessage_Value;



const sub2 = StaffValue + DepartmentValue + PositionValue + SkillValue + SetupValue;
const sub3 = StaffReportValue + LeaveReportValue + AttendanceValue + StaffScheduleValue;
const sub2_addmin = CarActivityValue + LettersValue + RightManagerValue + TelegramSendMessageValue;
const sub4 = BloodDonationValue + AccidentValue + CaseValue + CaseWeekendReportValues + CaseGraphicValue;
const sub5 = BankValue;
const sub7 = RoleValue;

const rootSubmenuKeys = ["sub1", "sub2", "sub4"];

function LayoutMaster() {
  const { i18n, t } = useTranslation();
  const linklogo_kh = process.env.PUBLIC_URL + "/flag/kh.jpg";
  const linklogo_eng = process.env.PUBLIC_URL + "/flag/eng.png";

  const [isMobile, setIsMobile] = useState(false);
  const [linkLanguage, setLinkLanguage] = useState(linklogo_kh);
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [openKeys, setOpenKeys] = useState(["sub1"]);
  const [collapsed, setCollapsed] = useState(false);
  const [visableUpdatePassword, setVisableUpdatePassword] = useState(false);

  // FIX: Dynamic state to track active highlighted tab selection
  const [selectedKeys, setSelectedKeys] = useState(["1"]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768 || window.innerWidth <= 1390) {
        setIsMobile(true);
        setCollapsed(true);
        setMobileMenuVisible(false); // Hide mobile menu on resize
      } else {
        setIsMobile(false);
        setCollapsed(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  useEffect(() => {
    if (!isGetLogin()) {
      window.location.href = "/login";
    }
  });
  // Debug: log login state and token for diagnosing unexpected redirects
  useEffect(() => {
    try {
      const t = localStorage.getItem('token');
      const p = localStorage.getItem('profile');
      const il = localStorage.getItem('isLogin');
      console.debug('DEBUG login state:', { tokenExists: !!t, tokenSample: t && (t.length > 20 ? t.slice(0, 20) + '...' : t), profileExists: !!p, isLogin: il });
    } catch (e) { console.debug('DEBUG login state read failed', e) }
  }, []);

  // Updated items with verified Tabler Icons
  const items = [
    getItem(t("Dashboard.label"), "sub1", <IconLayoutDashboard size={18} stroke={1.5} />, false, [
      getItem(t("Dashboard.subItems.Home"), "1", <IconHome size={18} stroke={1.5} />),
      getItem(t("Dashboard.subItems.Profile"), "24", <IconUserCircle size={18} stroke={1.5} />),
      getItem(t("Dashboard.subItems.MyMessageChat"), "30", <MessageFilled size={18} stroke={1.5} />),
      getItem(t("Dashboard.subItems.Attendance"), "25", <IconUserCheck size={18} stroke={1.5} />),
    ]),
    sub2 && getItem(t("Management.label"), "sub2", <IconUsers size={18} stroke={1.5} />, false, [
      StaffValue && getItem(t("Management.subItems.Staff"), "2", <IconUser size={18} stroke={1.5} />),
      DepartmentValue && getItem(t("Management.subItems.Department"), "3", <IconBuilding size={18} stroke={1.5} />),
      PositionValue && getItem(t("Management.subItems.Position"), "4", <IconAward size={18} stroke={1.5} />),
      SkillValue && getItem(t("Management.subItems.Skill"), "12", <IconCertificate size={18} stroke={1.5} />),
      SetupValue && getItem(t("Management.subItems.SetupType"), "5", <IconSettings size={18} stroke={1.5} />),
    ]),
    sub2_addmin && getItem(t("Administrative.label"), "sub2-1", <IconFileText size={18} stroke={1.5} />, false, [
      CarActivityValue && getItem(t("Administrative.subItems.CarMission"), "9", <IconCar size={18} stroke={1.5} />),
      RequestMissionValue && getItem(t("Administrative.subItems.RequestMission"), "26", <IconFile size={18} stroke={1.5} />),
      LettersValue && getItem(t("Administrative.subItems.MissionLetters"), "13", <IconMailForward size={18} stroke={1.5} />),
      RightManagerValue && getItem(t("Administrative.subItems.RightManager"), "15", <IconUserShare size={18} stroke={1.5} />),
      TelegramSendMessageValue && getItem(t("Administrative.subItems.TelegramSendMessage"), "29", <IconBrandTelegram size={18} stroke={1.5} />),
    ]),
    sub3 && getItem(t("Report.label"), "sub3", <IconChartBar size={18} stroke={1.5} />, false, [
      StaffReportValue && getItem(t("Report.subItems.StaffReport"), "6", <IconFileText size={18} stroke={1.5} />),
      LeaveReportValue && getItem(t("Report.subItems.LeaveReport"), "7", <IconFileDescription size={18} stroke={1.5} />),
      AttendanceValue && getItem(t("Report.subItems.Attendance"), "14", <IconChartLine size={18} stroke={1.5} />),
      StaffScheduleValue && getItem(t("Report.subItems.StaffScheduler"), "16", <IconCalendar size={18} stroke={1.5} />),
    ]),
    sub4 && getItem(t("DataManagement.label"), "sub4", <IconClipboardList size={18} stroke={1.5} />, false, [
      BloodDonationValue && getItem(t("DataManagement.subItems.blood_donation"), "28", <IconDroplet size={18} stroke={1.5} />),
      AccidentValue && getItem(t("DataManagement.subItems.case_accident_form"), "27", <IconFirstAidKit size={18} stroke={1.5} />),
      CaseValue && getItem(t("DataManagement.subItems.CaseManager"), "20", <IconFirstAidKit size={18} stroke={1.5} />),
      CaseWeekendReportValues && getItem(t("DataManagement.subItems.CaseWeekly"), "23", <IconFirstAidKit size={18} stroke={1.5} />),
      CaseGraphicValue && getItem(t("DataManagement.subItems.CaseChart"), "22", <IconChartPie size={18} stroke={1.5} />),
    ]),
    sub5 && getItem(t("AccountingManagement.label"), "sub7", <IconBuildingBank size={18} stroke={1.5} />, false, [
      BankValue && getItem(t("AccountingManagement.subItems.BankingReport"), "21", <IconCurrencyDollar size={18} stroke={1.5} />),
    ]),
    sub7 && getItem(t("Setting.label"), "sub5", <IconSettings size={18} stroke={1.5} />, false, [
      RoleValue && getItem(t("Setting.subItems.Role"), "11", <IconUser size={18} stroke={1.5} />),
      TelegramBotSettingValues && getItem(t("Setting.subItems.Management"), "19", <IconShieldCheck size={18} stroke={1.5} />),
    ]),
  ];

  const onLogout = async () => {
    try {
      setLoadingSpin(true);
      await new Promise((resolve) => setTimeout(resolve, 600));
      localStorage.setItem("isLogin", null);
      localStorage.setItem("permission", null);
      window.location.href = "/login";
      window.localStorage.clear();
    } catch (error) {
    } finally {
      setLoadingSpin(false);
    }
  };

  const { token: { colorBgContainer } } = theme.useToken();
  const navigate = useNavigate();
  const onLinkPage = (routeName) => navigate(routeName);

  // FIX: Added line `setSelectedKeys([e.key]);` so state handles item highlighting seamlessly
  const onClickMenu = (e) => {
    // Hide mobile menu when a menu item is clicked
    if (isMobile) {
      setMobileMenuVisible(false);
    }
    setSelectedKeys([e.key]);
    if (e.key == 1) onLinkPage("/");
    else if (e.key == 2) onLinkPage("/user");
    else if (e.key == 3) onLinkPage("/department");
    else if (e.key == 4) onLinkPage("/position");
    else if (e.key == 5) onLinkPage("/setuptype");
    else if (e.key == 6) onLinkPage("/employee");
    else if (e.key == 7) onLinkPage("/leave");
    else if (e.key == 8) onLinkPage("/usersetting");
    else if (e.key == 9) onLinkPage("/caractivity");
    else if (e.key == 10) onLinkPage("/setting");
    else if (e.key == 11) onLinkPage("/rolepage");
    else if (e.key == 12) onLinkPage("/skillpage");
    else if (e.key == 13) onLinkPage("/letterspage");
    else if (e.key == 14) onLinkPage("/attendanceqrpage");
    else if (e.key == 15) onLinkPage("/rightmanager");
    else if (e.key == 16) onLinkPage("/staffschedule");
    else if (e.key == 17) onLinkPage("/stockin");
    else if (e.key == 18) onLinkPage("/stockout");
    else if (e.key == 19) onLinkPage("/telegrambot");
    else if (e.key == 20) onLinkPage("/case");
    else if (e.key == 21) onLinkPage("/bankingreport");
    else if (e.key == 22) onLinkPage("/casegraphic");
    else if (e.key == 23) onLinkPage("/weekendreport");
    else if (e.key == 24) onLinkPage("/profile");
    else if (e.key == 25) onLinkPage("/leaveuserprofile");
    else if (e.key == 26) onLinkPage("/requestmission");
    else if (e.key == 27) onLinkPage("/accidentform");
    else if (e.key == 28) onLinkPage("/blooddonation");
    else if (e.key == 29) onLinkPage("/telegramsendmessage");
    else if (e.key == 30) onLinkPage("/mymessagechat");
  };

  // Updated login dropdown with Tabler Icons
  const loginItem = [
    { label: "អំពីខ្ញុំ", key: "0", icon: <IconUser size={16} stroke={1.5} />, onClick: () => onLinkPage("/profile") },
    { label: "ផ្លាស់ប្តូរលេខសង្ងាត់", key: "1", icon: <IconLock size={16} stroke={1.5} />, onClick: () => setVisableUpdatePassword(true) },
    { label: "ចាកចេញ", key: "2", danger: true, icon: <IconLogout size={16} stroke={1.5} />, onClick: onLogout },
  ];

  const ItemLanguage = [
    { label: "Khmer", key: "0", onClick: () => { setLinkLanguage(linklogo_kh); i18n.changeLanguage("kh"); } },
    { label: "English", key: "1", onClick: () => { setLinkLanguage(linklogo_eng); i18n.changeLanguage("en"); } },
  ];

  const onFinish = async (values) => {
    try {
      var data = { username: userProfile.username, password: values.password, confirmPassword: values.passwordConfirm };
      const res = await request("user/set-password", "post", data);
      if (res.isSuccess) {
        setVisableUpdatePassword(false);
        setLoadingSpin(true);
        await new Promise((resolve) => setTimeout(resolve, 4000));
        localStorage.setItem("isLogin", "");
        window.location.href = "/login";
      }
    } catch (error) {
      openNotification("error", " password is not match !");
    } finally {
      setLoadingSpin(false);
    }
  };
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  // return (
  //   <div>
  //     {loadingSpin && <div className="sprinSave-container"><div className="sprinSave"><GetLoading /></div></div>}
  //     <Layout style={{ minHeight: "100vh" }}>

  //       {/* for ModernSidebar when mobile then show icon menu and when click show menu and when click again hide menu and when click other page then hide menu and when click other page then show menu and when click again hide menu
  //         */}
  //       <ModernSidebar
  //         collapsed={collapsed}
  //         setCollapsed={setCollapsed}
  //         items={items}
  //         openKeys={openKeys}
  //         onOpenChange={onOpenChange}
  //         onClickMenu={onClickMenu}
  //         selectedKeys={selectedKeys} // FIX: Bound to real dynamic array state variable
  //       />
  //       <Layout style={{ backgroundColor: "#f8f9f9" }}>
  //         <div style={{ display: "flex", justifyContent: "space-between", height: 50 }}>
  //           <Button
  //             type="text"
  //             icon={collapsed ? <IconChevronRight size={20} stroke={1.5} /> : <IconChevronLeft size={20} stroke={1.5} />}
  //             onClick={() => setCollapsed(!collapsed)}
  //             style={{ fontSize: "16px", paddingTop: 10, width: 40, height: 40 }}
  //           />
  //           <div style={{ display: "flex" }}>
  //             <Dropdown menu={{ items: ItemLanguage }} trigger={["click"]}>
  //               <a onClick={(e) => e.preventDefault()}>
  //                 <Space style={{ paddingLeft: 10, paddingTop: 10 }} className="styleTageStatusForm">
  //                   <Avatar className="ionavatarLaout" src={linkLanguage} />
  //                 </Space>
  //               </a>
  //             </Dropdown>
  //             <Dropdown menu={{ items: loginItem }} trigger={["click"]}>
  //               <a onClick={(e) => e.preventDefault()}>
  //                 <Space style={{ paddingLeft: 10, paddingTop: 10, paddingRight: 30 }} className="styleTageStatusForm">
  //                   <Badge count={5} size="small">
  //                     <Avatar className="ionavatarLaout" src={linkPath + userProfile?.image} />
  //                   </Badge>
  //                   <div style={{ backgroundColor: "#e5e7e9", padding: 5, borderRadius: 50, paddingRight: 20 }}>
  //                     <IconUser size={16} stroke={1.5} style={{ paddingLeft: 10, paddingRight: 10 }} />
  //                     {userProfile?.fullname}
  //                     <IconChevronDown size={16} stroke={1.5} />
  //                   </div>
  //                 </Space>
  //               </a>
  //             </Dropdown>
  //           </div>
  //         </div>
  //         <Content>
  //           <div style={{ padding: 10, minHeight: 360, background: colorBgContainer, height: "90vh", overflow: "auto" }}>
  //             <Outlet />
  //           </div>
  //         </Content>
  //         <Footer style={{ textAlign: "center", fontSize: "8px", padding: "10px 50px" }}>
  //           © 2024 Votmean Mobile. All rights reserved.
  //         </Footer>
  //       </Layout>
  //     </Layout>

  //     <Modal title="កែប្រែលេខសម្ងាត់ / Update Password " className={styels.textStyle} open={visableUpdatePassword} footer={[]} onCancel={() => setVisableUpdatePassword(false)}>
  //       <Form name="normal_login" onFinish={onFinish} initialValues={{ remember: true }}>
  //         <Form.Item name="password" rules={[{ required: true, message: "Please input your Password!" }]}>
  //           <Input className={styels.textStyle} prefix={<IconLock size={16} stroke={1.5} />} type="password" placeholder="New Password" />
  //         </Form.Item>
  //         <Form.Item name="passwordConfirm" rules={[{ required: true, message: "Please input your Password!" }]}>
  //           <Input className={styels.textStyle} prefix={<IconLock size={16} stroke={1.5} />} type="password" placeholder="Comfirm New Password" />
  //         </Form.Item>
  //         <Form.Item>
  //           <Button className={styels.textStyle} style={{ width: "100%" }} type="primary" htmlType="submit">Update</Button>
  return (
    <div>
      {loadingSpin && <div className="sprinSave-container"><div className="sprinSave"><GetLoading /></div></div>}
      <Layout style={{ height: "100vh", overflow: "hidden" }}>

        {/* ModernSidebar - Only show on desktop, or on mobile when menu is toggled */}
        {(!isMobile || mobileMenuVisible) && (
          <ModernSidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            items={items}
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            onClickMenu={onClickMenu}
            selectedKeys={selectedKeys}
          />
        )}

        <Layout style={{ backgroundColor: "#f8f9f9" }}>
          <div style={{ display: "flex", justifyContent: "space-between", height: 50 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* Desktop toggle button - only show on desktop */}
              {!isMobile && (
                <Button
                  type="text"
                  icon={collapsed ? <IconChevronRight size={20} stroke={1.5} /> : <IconChevronLeft size={20} stroke={1.5} />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{ fontSize: "16px", paddingTop: 10, width: 40, height: 40 }}
                />
              )}
              {/* Mobile Menu Toggle Button */}
              {isMobile && (
                <Button
                  type="text"
                  icon={<IconMenu2 size={20} stroke={1.5} />}
                  onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
                  style={{
                    fontSize: "16px",
                    paddingTop: 10,
                    width: 40,
                    height: 40,
                    marginLeft: 4
                  }}
                />
              )}
            </div>
            <div style={{ display: "flex" }}>
              <Dropdown menu={{ items: ItemLanguage }} trigger={["click"]}>
                <a onClick={(e) => e.preventDefault()}>
                  <Space style={{ paddingLeft: 10, paddingTop: 10 }} className="styleTageStatusForm">
                    <Avatar className="ionavatarLaout" src={linkLanguage} />
                  </Space>
                </a>
              </Dropdown>
              <Dropdown menu={{ items: loginItem }} trigger={["click"]}>
                <a onClick={(e) => e.preventDefault()}>
                  <Space style={{ paddingLeft: 10, paddingTop: 10, paddingRight: 30 }} className="styleTageStatusForm">
                    <Badge count={5} size="small">
                      <Avatar className="ionavatarLaout" src={linkPath + userProfile?.image} />
                    </Badge>
                    <div style={{ backgroundColor: "#e5e7e9", padding: 5, borderRadius: 50, paddingRight: 20 }}>
                      <IconUser size={16} stroke={1.5} style={{ paddingLeft: 10, paddingRight: 10 }} />
                      {userProfile?.fullname}
                      <IconChevronDown size={16} stroke={1.5} />
                    </div>
                  </Space>
                </a>
              </Dropdown>
            </div>
          </div>

          <Content style={{ height: "calc(100vh - 50px)", overflowY: "auto", display: "flex", flexDirection: "column" }}>
            <div style={{ padding: 10, flex: 1, display: "flex", flexDirection: "column" }}>
              <Outlet />
            </div>
          </Content>
          {/* <Footer style={{ textAlign: "center", fontSize: "8px", padding: "10px 50px" }}>
            © 2024 Votmean Mobile. All rights reserved.
          </Footer> */}
        </Layout>
      </Layout>

      <Modal
        title="កែប្រែលេខសម្ងាត់ / Update Password"
        className={styels.textStyle}
        open={visableUpdatePassword}
        footer={[]}
        onCancel={() => setVisableUpdatePassword(false)}
      >
        <Form name="normal_login" onFinish={onFinish} initialValues={{ remember: true }}>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input
              className={styels.textStyle}
              prefix={<IconLock size={16} stroke={1.5} />}
              type="password"
              placeholder="New Password"
            />
          </Form.Item>
          <Form.Item
            name="passwordConfirm"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input
              className={styels.textStyle}
              prefix={<IconLock size={16} stroke={1.5} />}
              type="password"
              placeholder="Confirm New Password"
            />
          </Form.Item>
          <Form.Item>
            <Button
              className={styels.textStyle}
              style={{ width: "100%" }}
              type="primary"
              htmlType="submit"
            >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
export default LayoutMaster;